import gsap from 'gsap';
import { q1O } from '../util/nE';
import state from '../state';
import { go } from '../barba/barba';

class Modal {
  constructor(el) {
    this.el = el;
    this.id = this.el.dataset.modalId || 'default';

    this.openTriggers = document.querySelectorAll(
      `[data-modal-trigger="${this.id}"]`
    );
    this.closeModal = this.el.querySelector('.btn--close');
    this.modalBlank = this.el.querySelector('.modal__blank');
  }

  resetTriggers() {
    this.openTriggers = document.querySelectorAll(
      `[data-modal-trigger="${this.id}"]`
    );

    this.openTriggers.forEach(trigger => {
      trigger.removeEventListener('click', this.resetTriggers);
      trigger.addEventListener('click', e => {
        e.preventDefault();
        this.openModal();
      });
    });
  }

  init() {
    this.bindModalOpen();

    const urlWithoutSearch = window.location.origin + window.location.pathname;
    const approved = localStorage.getItem(urlWithoutSearch);
    if (window.location.search.includes('aliId')) {
      localStorage.setItem(urlWithoutSearch, true);
    }
    if (this.el.dataset.modalOpen == true && !approved) {
      this.openModal();
    }
    window.addEventListener('page:ready', this.resetTriggers.bind(this), {
      passive: true,
    });
  }
  openModal() {
    gsap.to(this.el, {
      autoAlpha: 1,
      duration: 0.6,
      ease: t => {
        return q1O(t);
      },
    });

    if (state.cursor) {
      state.cursor.onCursorHide();
    }

    if (state.smoothScroll) {
      state.smoothScroll.lenis.stop();
    }
  }
  bindModalOpen() {
    const closeAnimation = () => {
      gsap.to(this.el, {
        autoAlpha: 0,
        duration: 0.6,
        ease: t => q1O(t),
        onStart: () => {
          const url = new URL(window.location.href);
          if (window.location.pathname.includes('/contact')) {
            go('/');
          } else if (url.searchParams.has('modal')) {
            url.searchParams.delete('modal');
            window.history.pushState({}, '', url);
          }
        },
      });

      if (state.cursor) {
        state.cursor.onCursorShow(this.el);
      }

      if (state.smoothScroll) {
        state.smoothScroll.lenis.start();
      }
    };

    this.openTriggers.forEach(trigger => {
      trigger.addEventListener('click', e => {
        e.preventDefault();
        this.openModal();
      });
    });

    if (this.closeModal) {
      this.closeModal.addEventListener('click', () => {
        closeAnimation();
      });
    }

    this.modalBlank.addEventListener('click', () => {
      closeAnimation();
    });
  }

  destroy() {}
}

export default Modal;



//////////////////
// WEBPACK FOOTER
// ./scripts/components/Modal.js
// module id = 54
// module chunks = 0